module.exports = __webpack_public_path__ + "media/C_game_lose.b8babeca.mp3";